export function setOferteLoading (state, loading = false) {
  state.oferteLoading = loading
}

export function setOferte (state, data ) {
  state.oferte = data.oferte.data
  state.oferteCurrentPage = data.oferte.current_page
  state.oferteLastPage = data.oferte.last_page
  state.ofertePerPage = data.oferte.per_page
  state.oferteTotal = data.oferte.total
  state.oferteRequestTotal = data.total_request || 0
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}

export function setSearch (state, search = '') {
  state.search = search
}

export function setDatefrom (state, datefrom = '') {
  state.datefrom = datefrom
}

export function setDateto (state, dateto = '') {
  state.dateto = dateto
}
